<template>
    <div class="import-data-container">
        <div class="card-container" v-if="Status.LoadingCompleted">
            <div class="info-box info">
                <i class="el-icon-info"></i>
                <div>
                    <p><strong>说明：</strong></p>
                    <ul>
                        <li>请上传包含考生数据的压缩包（支持.rar、.zip格式）</li>
                        <li>压缩包必须包含T_BMK.dbf或T_TDD.dbf等DBF格式文件</li>
                        <li>系统将自动识别省份并解析考生信息、成绩、志愿等数据</li>
                        <li>导入过程中会显示实时进度</li>
                    </ul>
                </div>
                            </div>

            <validation-observer v-slot="{ invalid }">
                <el-form :model="Model" label-width="140px" class="import-form">
                    <el-form-item label="导入类型">
                        <validation-provider rules="required" tag="div" v-slot="{ errors }" name="导入类型">
                            <el-select v-model.number="Model.Type" placeholder="请选择导入类型" style="width: 100%;">
                                <el-option label="1 - 压缩包" :value="1"></el-option>
                            </el-select>
                            <span class="error-text" v-if="errors[0]">{{ errors[0] }}</span>
                        </validation-provider>
                    </el-form-item>

                    <el-form-item label="数据文件压缩包">
                        <validation-provider rules="required" tag="div" :immediate="true" v-slot="{ errors, validate }" name="数据文件压缩包">
                            <el-upload
                                class="upload-demo"
                                action="#"
                                :auto-upload="false"
                                :on-change="(file) => OnFileChanged(file, validate)"
                                :on-remove="OnFileRemove"
                                :on-exceed="OnFileExceed"
                                :file-list="fileList"
                                accept=".rar,.zip"
                                :limit="1">
                                <el-button slot="trigger" size="small" type="primary">选择文件</el-button>
                                <div slot="tip" class="el-upload__tip">只能上传rar/zip文件，且不超过500MB。再次选择会替换当前文件。</div>
                            </el-upload>
                            <span class="error-text" v-if="errors[0]">{{ errors[0] }}</span>
                        </validation-provider>
                    </el-form-item>

                    <el-form-item>
                        <el-button type="primary" size="large" :disabled="IsFormDataInvalid(invalid)" @click="OnSubmit" :loading="Status.IsSubmiting">
                            <span v-if="!Status.IsSubmiting">开始导入</span>
                            <span v-else>导入中...</span>
                        </el-button>
                        <el-button v-if="IsAdmin==1" type="danger" size="large" @click="OnClearData" :loading="Status.IsSubmiting" style="margin-left: 20px;">
                            清空全部数据（测试用）
                        </el-button>
                    </el-form-item>
                </el-form>
            </validation-observer>

            <!-- 结果显示 -->
            <div v-if="Result" class="result-container">
                <el-divider>导入结果</el-divider>
                <div v-html="Result" class="result-content"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import { TYBM_Env } from '../../env.js';
    import { TYBM_Tools } from '../../tools.js';
    import { ValidationProvider, ValidationObserver } from 'vee-validate';

    export default {
        name: 'ImportData',
        inject: ['Loading', 'LoadingCompleted'],
        components: {
            ValidationProvider,
            ValidationObserver
        },
        data: function () {
            return {
                Status: {
                    LoadingCompleted: false,
                    IsSubmiting: false
                },
                Model: {
                    Type: 1
                },
                RarFile: null,
                fileList: [],
                Result: '',
                IsAdmin: 0
            }
        },
        methods: {
            OnYearChange() {
                // 如果需要根据年份刷新数据，可以在这里处理
                // 对于导入页面，主要是提交时需要年份，可以不在这里做特殊处理，
                // 只要提交时后端能从Session取到年份，或者这里显示一下当前年份（可选）
                // 但根据需求，是移除页面中的年份选择
            },
            OnLoad: function () {
                var that = this;
                var api_name = "/CheckLogin";
                var url = TYBM_Env.GetApiUrl(api_name);
                TYBM_Tools.AxiosGetEx(that, api_name, url, { loading_msg: '正在加载数据' }).then(result => {
                    that.IsAdmin = result.data.IsAdmin;
                }).catch(() => { });

                that.Status.LoadingCompleted = true;
            },
            IsFormDataInvalid: function (vee_invalid) {
                var that = this;
                return vee_invalid || !that.RarFile;
            },
            OnFileChanged: function (file, validate) {
                var that = this;
                // 清空旧文件列表，确保只保留新选择的文件
                that.fileList = [];
                that.RarFile = file.raw;
                that.fileList = [file];
                validate(file).then(e => {
                    if (!e.valid) {
                        that.RarFile = null;
                        that.fileList = [];
                    }
                });
            },
            OnFileRemove: function () {
                var that = this;
                that.RarFile = null;
                that.fileList = [];
            },
            OnFileExceed: function (files) {
                // 当选择新文件超过限制时，替换原有文件
                var that = this;
                that.fileList = [];
                that.$nextTick(() => {
                    // 使用新文件替换
                    that.RarFile = files[0];
                    that.fileList = [{ name: files[0].name, raw: files[0] }];
                });
            },
            OnSubmit: function () {
                var that = this;
                var api_name = "/Data/ImportData";
                var data = { "Model": JSON.stringify(that.Model), "RarFile": that.RarFile };
                // 拼接 year 参数以确保后端 Session 更新
                var year = this.$root.currentYear || '';
                var url = TYBM_Env.GetApiUrl(api_name) + (year ? '?year=' + year : '');
                
                that.Status.IsSubmiting = true;
                TYBM_Tools.AxiosUploadFile(that, api_name, url, data, { loading_msg: '正在处理', has_progress: true })
                    .then(result => {
                        that.Result = result.data.Msg;
                        that.$message.success('导入成功');
                    })
                    .catch(() => {
                        that.$message.error('导入失败');
                    })
                    .finally(() => {
                        that.Status.IsSubmiting = false;
                    });
            },
            OnClearData: function () {
                var that = this;
                
                that.$confirm('此操作将清空当前院校当前年份的所有数据，是否继续？', '警告', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                var api_name = "/Data/ClearData";
                var url = TYBM_Env.GetApiUrl(api_name);
                    that.Status.IsSubmiting = true;
                TYBM_Tools.AxiosGetEx(that, api_name, url, { loading_msg: '正在处理', has_progress: true })
                    .then(result => {
                        that.Result = result.data.Msg;
                            that.$message.success('清空成功');
                    })
                    .catch(() => {
                            that.$message.error('清空失败');
                    })
                    .finally(() => {
                            that.Status.IsSubmiting = false;
                    });
                }).catch(() => {});
            }
        },
        created: function () {
            var that = this;
            that.OnLoad();
            // 监听全局年份变更
            this.$root.$on('global-year-change', this.OnYearChange);
        },
        beforeDestroy() {
            this.$root.$off('global-year-change', this.OnYearChange);
        }
    }
</script>

<style scoped>
.import-data-container {
    max-width: 900px;
}

.import-form {
    margin-top: 24px;
}

.info-box {
    padding: 16px;
    border-radius: 4px;
    margin-bottom: 24px;
    border-left: 4px solid;
    background-color: #e6f7ff;
    border-color: #1890ff;
    color: #0050b3;
    display: flex;
    gap: 12px;
}

.info-box i {
    font-size: 20px;
    margin-top: 2px;
}

.info-box ul {
    margin: 8px 0 0 20px;
    padding: 0;
}

.info-box li {
    margin: 4px 0;
}

.error-text {
    color: #f56c6c;
    font-size: 12px;
    line-height: 1;
    padding-top: 4px;
    display: block;
}

.result-container {
    margin-top: 32px;
}

.result-content {
    padding: 20px;
    background-color: #f5f7fa;
    border-radius: 8px;
    border: 1px solid #e4e7ed;
    min-height: 100px;
    max-height: 500px;
    overflow-y: auto;
}

/* 隐藏el-upload的原生input */
.import-form >>> .el-upload {
    display: inline-block;
}

.import-form >>> .el-upload input[type="file"] {
    display: none !important;
}
</style>
